import { css } from '@emotion/react';
import styled from '@emotion/styled';
import ReloadIcon from '@/assets/icons/reload.svg?react';
import WarningIcon from '@/assets/icons/warning.svg?react';
import { fadeInDown, fadeOutUp } from '../../data';

export const ReloadButtonIcon = styled(ReloadIcon)`
  width: auto;
  height: 80%;
  transition: all 0.3s ease;
`;

export const ReloadButton = styled.button`
  display: flex;
  flex: none;
  align-items: center;
  height: 22px;
  padding: 3px 10px;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
  border-radius: 4px;
  background: #fff;
  gap: 6px;

  &:hover {
    color: #a15857;
    border-color: #a15857;
    fill: #a15857;

    ${ReloadButtonIcon} {
      transform: rotate(180deg);
    }
  }
`;

export const WarningIconImage = styled(WarningIcon)`
  flex-shrink: 0;
  width: auto;
  max-height: 22px;

  path {
    stroke: #a15857;
  }
`;

export const PropertyErrorDescription = styled.p`
  position: relative;
  margin-top: 1px;
  color: #a15857;
  font-size: 11px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export type ErrorType = 'error' | 'warning';

export type ErrorMessageContainerProps = {
  show?: boolean;
  type?: ErrorType;
  firstRender?: boolean;
};

export const ErrorMessageContainer = styled.div<ErrorMessageContainerProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 30px;
  padding: 0 8px;
  border-bottom: 1px solid #ccc;
  background: rgb(252 250 248 / 40%);
  will-change: transform, height, margin;
  box-sizing: border-box;
  transition: all 0.35s ease;

  ${({ show }) =>
    show
      ? css`
          animation: ${fadeInDown({ maxHeight: 42 })} 0.35s ease both;
        `
      : css`
          margin: 0 !important;
          animation: ${fadeOutUp({ maxHeight: 42 })} 0.35s ease both;
        `}

  ${({ firstRender }) =>
    firstRender &&
    css`
      animation-duration: 0s;
    `};
`;

export const ErrorMessageWrapper = styled.div`
  position: static;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 5px 10px;
  width: 100%;
  max-width: 290px;
  padding: 6px 10px;
  border: 1px solid #a15857;
  border-radius: 8px;
  background: rgb(161 88 87 / 15%);
  gap: 10px;
`;
